import { jsx as _jsx } from "react/jsx-runtime";
import toast from "react-hot-toast";
import { Alert } from "../Alert";
import { AnimationWrapper } from "./styles";
const componentRender = (type, { description, title }) => {
    toast.remove();
    toast.custom(({ visible }) => {
        return (_jsx(AnimationWrapper, { visible: visible, children: _jsx(Alert, { type: type, title: title, closeable: true, onClose: toast.remove, toastMode: true, children: description }) }));
    });
};
export { Toaster } from "./Toaster";
export const notify = {
    positive(params) {
        componentRender("positive", params);
    },
    negative(params) {
        componentRender("negative", params);
    },
    warn(params) {
        componentRender("warn", params);
    },
    info(params) {
        componentRender("info", params);
    },
    remove() {
        toast.remove();
    },
};
//# sourceMappingURL=index.js.map